import axios from "axios";

// Thin wrapper over the NPD endpoints; the backend resolves the organization from the token.
const BASE = `${process.env.REACT_APP_BACKEND_URL}/npd`;

const auth = () => {
  const user = JSON.parse(localStorage.getItem("user") || "null");
  return { headers: { Authorization: `Bearer ${user?.accessToken}` } };
};

const data = (promise) => promise.then((res) => res.data);

export const npdApi = {
  context: () => data(axios.get(`${BASE}/context`, auth())),
  lines: () => data(axios.get(`${BASE}/assembly-lines`, auth())),
  addLine: (body) => data(axios.post(`${BASE}/assembly-lines`, body, auth())),
  updateLine: (id, body) => data(axios.put(`${BASE}/assembly-lines/${id}`, body, auth())),
  suppliers: () => data(axios.get(`${BASE}/suppliers`, auth())),
  addSupplier: (name) => data(axios.post(`${BASE}/suppliers`, { name }, auth())),
  buyers: () => data(axios.get(`${BASE}/buyers`, auth())),
  parts: () => data(axios.get(`${BASE}/parts`, auth())),
  part: (id) => data(axios.get(`${BASE}/parts/${id}`, auth())),
  addPart: (body) => data(axios.post(`${BASE}/parts`, body, auth())),
  importParts: (body) => data(axios.post(`${BASE}/parts/import`, body, auth())),
  action: (id, body) => data(axios.post(`${BASE}/parts/${id}/actions`, body, auth())),
};

export const errorMessage = (error, fallback = "Something went wrong. Please try again.") =>
  error?.response?.data?.Exception || error?.response?.data?.message || fallback;
